//angular references
//import { NgForm } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Component, HostListener, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
//Dialog references
import { ConfirmationService, SelectItem } from 'primeng/api';
//Era model references
import { BusinessEvent, enumBusinessEventMode } from '../../models/businessevent.model';
import { enumCallStatus } from '../../models/callStatus.model';
import { Dialog } from '../../models/dialog.model';
import { DialogButton, enumDialogButtonType } from '../../models/dialogButton.model';
//import { OTA_VehAvailCore } from '../../models/ota_vehavailcore.model';
import { enumIdentStatus, enumIdentType, Identification } from '../../models/identification.model';
import { KeyValuePair } from '../../models/keyvaluepair.model';
import { Location } from '../../models/location.model';
import { OTA_Error } from '../../models/ota_error.model';
import { enumRequestType, OTA_Request } from '../../models/ota_request.model';
import { OTA_Response } from '../../models/ota_response.model';
//import { AgeRange } from '../../models/agerange.model';
import { OTA_VehAvail } from '../../models/ota_vehavail.model';
import { OTA_VehType } from '../../models/ota_vehtype.model';
import { enumPhoneType, Phone } from '../../models/phone.model';
import { enumAddressType, Address } from '../../models/address.model';
import { PromotionType } from '../../models/promotiontype.model';
//BusinessEvent control references
import { BEDataService } from '../../services/businessEvent/beData.service';
import { BEWorkflowSteps } from '../../services/businessEvent/beWorkflow.model';
//Service references
import { ConfigDataService, enumClientConfig, enumMultiPageMode, enumUIConfig, enumValidationMode } from '../../services/configuration/configData.service';
import { CachedDataService } from '../../services/dataCache/cachedData.service';
import { DictionaryService } from '../../services/dictionary/dictionary.service';
import { PortalDictionary } from '../../models/portaldictionary.model';


enum enumAsyncLoad {
    ClientConfigs = 1,
    VehicleTypes = 2,
    AgeRanges = 3,
    RentalTimesOut = 4,
    LocationsData = 5,
    DisplayAdditionalChargeTypes = 6,
    CustomCurrencies = 7,
    QueryParameters = 8,
    UIConfigs = 9,
    HideExtraChargeTypes = 10,
    Dictionary = 11,
    RentalTimesIn = 12,
};

enum enumRentalEdge {
    Out = 1,
    In = 2,
};

enum enumEntryMode {
    Add = 1,
    Search = 2,
};

enum enumDeliveryCollection {
    Unknown = 0,
    Delivery = 1,
    Collection = 2,
};

@Component({
    selector: 'beItinerary',
    template: require('./beItinerary.component.html'),
    styles: [require('../app/app.component.css')],
})

export class BEItineraryComponent {
    private _component = "beItinerary";

    //dictionary
    private _firstTabCaption_New: string = "New Booking";
    private _firstTabCaption_New_Short: string = "New";
    private _firstTabCaption_Modify: string = "Your booking - {0}";
    private _firstTabCaption_Modify_Short: string = "{0}";

    //page/workflow
    private _title = "Book a car";
    private _currentStep = BEWorkflowSteps.beItinerary;
    private _nextStep = "";
    private _firstTabCaption: string = "New Booking";
    private _firstTabCaptionShort: string = "New";
    private _clearButtonCaption: string = "Clear";
    private _ageAtPickUpCaption: string = "Your age at pick up";
    private _ageAtPickUpCaption_Short: string = "Your age at pick up";
    private _ageAtPickUpCaption_Long: string = "Your age at pick up";

    private _font: string = "";
    private _fontSize: string = "";
    private _textColour: string = "";
    private _invalidTextColour: string = "";
    private _invalidBorderColour: string = "";
    private _containerBackColour: string = "";
    private _containerBorderColour: string = "";
    private _containerCornerRadius: string = "";
    private _inactiveTabColour: string = "";
    private _containerBorderFull: string = "";
    private _hasMap: boolean = false;
    private _validationMode: enumValidationMode = enumValidationMode.valmode_Immediate;
    private _multiPageMode: enumMultiPageMode = enumMultiPageMode.mpmode_Tabs;
    private _showDeliveryCollection: boolean = false;
    private _showPromoTypes: boolean = false;

    private _locationOutTextColour: string = "";
    private _locationOutBorderColour: string = "";
    private _locationInTextColour: string = "";
    private _locationInBorderColour: string = "";
    private _dateTimeOutTextColour: string = "";
    private _dateTimeOutBorderColour: string = "";
    private _dateTimeInTextColour: string = "";
    private _dateTimeInBorderColour: string = "";
    private _ageRangeTextColour: string = "";
    private _ageRangeBorderColour: string = "";
    private _bookingRefTextColour: string = "";
    private _bookingRefBorderColour: string = "";
    private _emailRefTextColour: string = "";
    private _emailRefBorderColour: string = "";

    private _commandButtonFont: string = "";
    private _commandButtonRadius: string = "";
    private _commandButtonTextSize: string = "";
    private _configuredCommandButtonTextSize: string = "";
    private _commandButtonTextWeight: string = "";
    private _primaryCommandButtonTextColour: string = "";
    private _primaryCommandButtonBackColour: string = "";
    private _primaryCommandButtonBorderFull: string = "";
    private _secondaryCommandButtonTextColour: string = "";
    private _secondaryCommandButtonBackColour: string = "";
    private _secondaryCommandButtonBorderFull: string = "";

    private _checkboxTickColour: string = "";
    private _checkboxTickedBackColour: string = "";
    private _checkboxUntickedBackColour: string = "";
    private _checkboxBorderColour: string = "";

    private _delAddrTextColour: string = "";
    private _delAddrBorderColour: string = "";
    private _colAddrTextColour: string = "";
    private _colAddrBorderColour: string = "";

    private _baseIconImgURL: string = "/img/icons/";

    //loaded
    private _fullyLoaded: boolean = false;
    private _loadingErrorMsgs: string[] = new Array();
    private _validationErrorMsgs: string[] = new Array();
    private _searchValidationErrorMsgs: string[] = new Array();
    private _loaded = [
        {
            step: enumAsyncLoad.ClientConfigs,
            loaded: false,
        },
        {
            step: enumAsyncLoad.VehicleTypes,
            loaded: false,
        },
        {
            step: enumAsyncLoad.AgeRanges,
            loaded: false,
        },
        {
            step: enumAsyncLoad.RentalTimesOut,
            loaded: false,
        },
        {
            step: enumAsyncLoad.LocationsData,
            loaded: false,
        },
        {
            step: enumAsyncLoad.DisplayAdditionalChargeTypes,
            loaded: false,
        },
        {
            step: enumAsyncLoad.CustomCurrencies,
            loaded: false,
        },
        {
            step: enumAsyncLoad.QueryParameters,
            loaded: false,
        },
        {
            step: enumAsyncLoad.UIConfigs,
            loaded: false,
        },
        {
            step: enumAsyncLoad.HideExtraChargeTypes,
            loaded: false,
        },
        {
            step: enumAsyncLoad.Dictionary,
            loaded: false,
        },
        {
            step: enumAsyncLoad.RentalTimesIn,
            loaded: false,
        },
    ];

    //query string parameters
    private _query_LocOut: string = "";
    private _query_PromoCode: string = "";

    //business event parameters
    private _be: BusinessEvent;
    private _reference: string;
    private _vehicleTypeId = -1;
    private _dropOffDifferent: boolean = false;
    private _dateOut: string;
    private _timeOut: string;
    private _dateIn: string;
    private _timeIn: string;
    private _ageRangeId = -1;
    private _promotionTypeId = -1;
    private _promoCode: string;
    private _entryMode: enumEntryMode = enumEntryMode.Add;
    private _locationOutx: Location;
    private _locationsOutx: SelectItem[] = new Array<SelectItem>();
    private _locationInx: Location;
    private _locationsInx: SelectItem[] = new Array<SelectItem>();

    //delivery/collection dialog parameters
    private _showDelCol: boolean = false;
    private _hasDelivery: boolean = false;
    private _hasCollection: boolean = false;
    private _hasDeliveryError: boolean = false;
    private _hasCollectionError: boolean = false;
    private _delColChanged: boolean = false;
    private _deliveryAddress: string = "";
    private _collectionAddress: string = "";
    private _activatedEdge: enumDeliveryCollection = enumDeliveryCollection.Unknown;

    private _tmpHasDelivery: boolean = false;
    private _tmpHasCollection: boolean = false;
    private _tmpDeliveryAddress: string = "";
    private _tmpCollectionAddress: string = "";

    //search parameters
    private _searchBookingReference: string;
    private _searchEmail: string;
    private _searching: boolean = false;
    private _otaResponse: OTA_Response;

    //lists
    private _locationsOut: Location[];
    private _locationsIn: Location[];

    private _vehicleTypes: KeyValuePair[];
    private _rentalTimesOut: string[];
    private _rentalTimesIn: string[];
    private _ageRanges: KeyValuePair[];
    private _promoTypes: PromotionType[];

    //error/change tracking
    private _hasChanged: boolean = false;
    private _hasError: boolean = false;
    private _hasSubmitError: boolean = false;
    private _hasSearchError: boolean = false;
    private _hasSearchSubmitError: boolean = false;
    private _hasVehicleTypeError: boolean = false;
    private _hasLocationOutError: boolean = false;
    private _hasLocationInError: boolean = false;
    private _hasDateTimeOutError: boolean = false;
    private _hasDateTimeInError: boolean = false;
    private _hasAgeRangeError: boolean = false;
    private _hasPromoCodeError: boolean = false;

    private _hasSearchBookingRefError: boolean;
    private _hasSearchEmailRefError: boolean;
    private _doValidation: boolean = false;
    private _doSearchValidation: boolean = false;

    //helpers
    private _todaysDate = new Date().toISOString().split('T')[0];

    //modal dialog
    private _dialog: Dialog = new Dialog();

    //location map
    private _map: google.maps.Map;
    private _showMap: boolean = false;
    private _mapOptions: any;
    private _mapOverlays: any[] = [];
    private _mapStyle = {
        'width': '100%',
        'height': '250px',
    };
    private _defaultZoom: number = 11;
    private _allLocationsZoom: number = -1;
    private _allLocationsCentre: google.maps.LatLng;

    @HostListener('window:resize', ['$event'])
    getScreenSize(event?) {
        this._fontSize = (window.innerWidth < 420 ? "12px" : "");
        this._fontSize = (window.innerWidth < 380 ? "10px" : this._fontSize);
        this._fontSize = (window.innerWidth < 350 ? "8px" : this._fontSize);
        this._fontSize = (window.innerWidth < 330 ? "6px" : this._fontSize);
        this._fontSize = (window.innerWidth < 310 ? "4px" : this._fontSize);

        this._commandButtonTextSize = (window.innerWidth < 420 ? "12px" : this._configuredCommandButtonTextSize);
        this._commandButtonTextSize = (window.innerWidth < 380 ? "10px" : this._commandButtonTextSize);
        this._commandButtonTextSize = (window.innerWidth < 350 ? "8px" : this._commandButtonTextSize);
        this._commandButtonTextSize = (window.innerWidth < 330 ? "6px" : this._commandButtonTextSize);
        this._commandButtonTextSize = (window.innerWidth < 310 ? "4px" : this._commandButtonTextSize);

        this._ageAtPickUpCaption = (window.innerWidth < 750 ? this._ageAtPickUpCaption_Short : this._ageAtPickUpCaption_Long);
    }
    //
    //component events
    //
    public constructor(private _router: Router,
        private _activatedRoute: ActivatedRoute,
        private _beDataService: BEDataService,
        private _configDataService: ConfigDataService,
        private _cachedDataService: CachedDataService,
        private _dictionaryService: DictionaryService,
        private _httpClient: HttpClient,
        @Inject('BASE_URL') private _baseUrl: string,
        private _confirmationService: ConfirmationService) {

        this._nextStep = this._beDataService.nextStep(this._currentStep);
        this._entryMode = enumEntryMode.Add;
    }

    private async ngOnInit() {
        //initialise the list of available Promotion types
        this._promoTypes = PromotionType.promotionTypes();

        //read any query params
        this._activatedRoute.queryParams.subscribe(params => {
            //this._query_LocOut = params['location'];

            var promoCode: string = params['promo'];
            if (promoCode != null) {
                promoCode = promoCode.trim();
                this._query_PromoCode = promoCode;
            }

            this.asyncLoaded(enumAsyncLoad.QueryParameters);
        }, error => console.error(error));

        //get the available Locations
        if (this._cachedDataService.locations == null) {
            this._httpClient.get<Location[]>(this._baseUrl + 'api/LocationsData').subscribe(result => {
                this._cachedDataService.locations = result;
                this.asyncLoaded(enumAsyncLoad.LocationsData);
            }, error => console.error(error));
        }
        else 
            this.asyncLoaded(enumAsyncLoad.LocationsData);

        //get the configured ClientConfigs
        if (this._configDataService.clientConfigs == null) {
            this._httpClient.get<KeyValuePair[]>(this._baseUrl + 'api/ConfigData/ClientConfigs').subscribe(result => {
                this._configDataService.clientConfigs = result;
                this.asyncLoaded(enumAsyncLoad.ClientConfigs);
            }, error => console.error(error));
        }
        else
            this.asyncLoaded(enumAsyncLoad.ClientConfigs);

        //get the configured DisplayAdditionalChargeTypes
        if (this._configDataService.displayAdditionalChargeTypes == null) {
            this._httpClient.get<KeyValuePair[]>(this._baseUrl + 'api/ConfigData/DisplayAdditionChargeTypes').subscribe(result => {
                this._configDataService.displayAdditionalChargeTypes = result;
                this.asyncLoaded(enumAsyncLoad.DisplayAdditionalChargeTypes);
            }, error => console.error(error));
        }
        else
            this.asyncLoaded(enumAsyncLoad.DisplayAdditionalChargeTypes);

        //get the configured HideExtraChargeTypes
        if (this._configDataService.hideExtraChargeTypes == null) {
            this._httpClient.get<KeyValuePair[]>(this._baseUrl + 'api/ConfigData/HideExtraChargeTypes').subscribe(result => {
                this._configDataService.hideExtraChargeTypes = result;
                this.asyncLoaded(enumAsyncLoad.HideExtraChargeTypes);
            }, error => console.error(error));
        }
        else
            this.asyncLoaded(enumAsyncLoad.HideExtraChargeTypes);

        //get the configured Vehicle Types
        if (this._configDataService.vehicleTypes == null) {
            this._httpClient.get<KeyValuePair[]>(this._baseUrl + 'api/ConfigData/VehicleTypes').subscribe(result => {
                this._configDataService.vehicleTypes = result;
                this.asyncLoaded(enumAsyncLoad.VehicleTypes);
            }, error => console.error(error));
        }
        else
            this.asyncLoaded(enumAsyncLoad.VehicleTypes);

        ////get the configured Promo Types
        //this._httpClient.get<KeyValuePair[]>(this._baseUrl + 'api/ConfigData/PromoTypes').subscribe(result => {
        //    //this._promoTypes = result;
        //    this.asyncLoaded(enumAsyncLoad.PromoTypes);
        //}, error => console.error(error));

        //get the configured Age Ranges
        if (this._configDataService.ageRanges == null) {
            this._httpClient.get<KeyValuePair[]>(this._baseUrl + 'api/ConfigData/AgeRanges').subscribe(result => {
                this._configDataService.ageRanges = result;
                this.asyncLoaded(enumAsyncLoad.AgeRanges);
            }, error => console.error(error));
        }
        else
            this.asyncLoaded(enumAsyncLoad.AgeRanges);

        //get the configured Rental Times Out
        if (this._configDataService.rentalTimesOut == null) {
            this._httpClient.get<string[]>(this._baseUrl + 'api/ConfigData/RentalTimesOut').subscribe(result => {
                this._configDataService.rentalTimesOut = result;
                this.asyncLoaded(enumAsyncLoad.RentalTimesOut);
            }, error => console.error(error));
        }
        else
            this.asyncLoaded(enumAsyncLoad.RentalTimesOut);

        //get the configured CustomCurrencies
        if (this._configDataService.customCurrencies == null) {
            this._httpClient.get<KeyValuePair[]>(this._baseUrl + 'api/ConfigData/CustomCurrencies').subscribe(result => {
                this._configDataService.customCurrencies = result;
                this.asyncLoaded(enumAsyncLoad.CustomCurrencies);
            }, error => console.error(error));
        }
        else
            this.asyncLoaded(enumAsyncLoad.CustomCurrencies);

        //get the configured UIConfigs
        if (this._configDataService.uiConfigs == null) {
            this._httpClient.get<KeyValuePair[]>(this._baseUrl + 'api/ConfigData/UIConfigs').subscribe(result => {
                this._configDataService.uiConfigs = result;
                this.asyncLoaded(enumAsyncLoad.UIConfigs);
            }, error => console.error(error));
        }
        else
            this.asyncLoaded(enumAsyncLoad.UIConfigs);

        //get the configured Dictionary
        if (this._dictionaryService.dictionaries == null) {
            this._httpClient.get<PortalDictionary[]>(this._baseUrl + 'api/DictionaryData/PortalDictionaries').subscribe(result => {
                this._dictionaryService.dictionaries = result;
                this.asyncLoaded(enumAsyncLoad.Dictionary);
            }, error => console.error(error));
        }
        else
            this.asyncLoaded(enumAsyncLoad.Dictionary);

        //get the configured Rental Times In
        if (this._configDataService.rentalTimesIn == null) {
            this._httpClient.get<string[]>(this._baseUrl + 'api/ConfigData/RentalTimesIn').subscribe(result => {
                this._configDataService.rentalTimesIn = result;
                this.asyncLoaded(enumAsyncLoad.RentalTimesIn);
            }, error => console.error(error));
        }
        else
            this.asyncLoaded(enumAsyncLoad.RentalTimesIn);
    }

    private async ngAfterViewChecked() {
        //style the checkboxes based on their state
        if ((this._checkboxTickColour.length > 0)
            || (this._checkboxTickedBackColour.length > 0)
            || (this._checkboxUntickedBackColour.length > 0)
            || (this._checkboxBorderColour.length > 0)) {

            //default with unticked style
            var checkboxes = document.getElementsByClassName('ui-chkbox-box') as HTMLCollectionOf<HTMLElement>;
            Array.from(checkboxes).forEach(checkbox => {
                checkbox.style.backgroundColor = this._checkboxUntickedBackColour;
                checkbox.style.borderColor = this._checkboxBorderColour;
            });

            //apply ticked style to any ticked checkboxes
            var tickedCheckboxes = document.getElementsByClassName('ui-chkbox-box ui-state-active') as HTMLCollectionOf<HTMLElement>;
            Array.from(tickedCheckboxes).forEach(checkbox => {
                checkbox.style.backgroundColor = this._checkboxTickedBackColour;
                checkbox.style.color = this._checkboxTickColour;
            });
        }
    }

    //
    //component management
    //
    private asyncLoaded(step: enumAsyncLoad) {
        let fullyLoaded: boolean = true;

        for (var i = 0; i < this._loaded.length; i++) {
            if (this._loaded[i].step === step) {
                //record the given step as being loaded
                this._loaded[i].loaded = true;
            }
            else if (!this._loaded[i].loaded) {
                //check if all async steps have been loaded
                fullyLoaded = false;
            }
        }

        switch (step) {
            case enumAsyncLoad.ClientConfigs:
                var baseIconImgURL = "/img/icons/";
                let configIconImgURL: string = this._configDataService.getClientConfig(enumClientConfig.cconf_IconImageFolder, baseIconImgURL);
                if (configIconImgURL.trim().length > 0) {
                    this._baseIconImgURL = configIconImgURL;
                }

                let showDelColl: string = this._configDataService.getClientConfig(enumClientConfig.cconf_ShowDeliveryCollection);
                if (showDelColl.trim().length > 0) {
                    this._showDeliveryCollection = (showDelColl == "1");
                }

                let showPromoTypes: string = this._configDataService.getClientConfig(enumClientConfig.cconf_ShowPromoTypes);
                if (showPromoTypes.trim().length > 0) {
                    this._showPromoTypes = (showPromoTypes == "1");
                }

                break;

            case enumAsyncLoad.VehicleTypes:
                this._vehicleTypes = this._configDataService.vehicleTypes;
                break;

            case enumAsyncLoad.AgeRanges:
                this._ageRanges = this._configDataService.ageRanges;
                break;

            case enumAsyncLoad.RentalTimesOut:
                this._rentalTimesOut = this._configDataService.rentalTimesOut;
                break;

            case enumAsyncLoad.LocationsData:
                var locations: Location[] = this._cachedDataService.locations;

                if (locations != null) {
                    //filter the locations for those that can be rented from/to
                    this._locationsOut = locations.filter(loc => (loc.rentFrom && (!loc.hideInWebList)));
                    this._locationsIn = locations.filter(loc => (loc.returnTo && (!loc.hideInWebList)));

                    this.configureMap();

                    for (var loc in locations) {
                        if (locations[loc].rentFrom && (!locations[loc].hideInWebList)) {
                            var locOut: SelectItem = { label: locations[loc].description, value: locations[loc] };
                            this._locationsOutx.push(locOut);
                        }

                        if (locations[loc].returnTo && (!locations[loc].hideInWebList)) {
                            var locIn: SelectItem = { label: locations[loc].description, value: locations[loc] };
                            this._locationsInx.push(locIn);
                        }
                    }
                }
                break;

            case enumAsyncLoad.UIConfigs:
                let font: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_Font);
                let textColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_TextColour);
                let invalidTextColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_InvalidTextColour);
                let invalidBorderColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_InvalidControlBorderColour);
                let containerBackColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_ContainerBackgroundColour);
                let containerBorderColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_ContainerBorderColour);
                let containerCornerRadius: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_ContainerCornerRadius);
                let inactiveTabColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_InactiveTabColour);
                let containerBorderStyle: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_ContainerBorderStyle);
                let hasMap: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_HasMap);
                let validationMode: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_ValidationMode);
                let multiPageMode: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_MultiPageMode);

                let commandButtonFont: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_CommandButtonFont);
                let commandButtonRadius: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_CommandButtonRadius);
                let commandButtonTextSize: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_CommandButtonTextSize);
                let commandButtonTextWeight: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_CommandButtonTextWeight);
                let primaryCommandButtonTextColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_PrimaryCommandButtonTextColour);
                let primaryCommandButtonBackColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_PrimaryCommandButtonBackgroundColour);
                let primaryCommandButtonBorderColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_PrimaryCommandButtonBorderColour);
                let primaryCommandButtonBorderStyle: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_PrimaryCommandButtonBorderStyle);

                let secondaryCommandButtonTextColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_SecondaryCommandButtonTextColour);
                let secondaryCommandButtonBackColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_SecondaryCommandButtonBackgroundColour);
                let secondaryCommandButtonBorderColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_SecondaryCommandButtonBorderColour);
                let secondaryCommandButtonBorderStyle: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_SecondaryCommandButtonBorderStyle);

                let checkboxTickColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_CheckboxTickColour);
                let checkboxTickedBackColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_CheckboxTickedBackColour);
                let checkboxUntickedBackColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_CheckboxUntickedBackColour);
                let checkboxBorderColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_CheckboxBorderColour);

                let ageAtPickUpCaptionShort: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_AgeAtPickUpCaption_Short);
                if (ageAtPickUpCaptionShort.trim().length > 0) {
                    this._ageAtPickUpCaption_Short = ageAtPickUpCaptionShort;
                }

                let ageAtPickUpCaptionLong: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_AgeAtPickUpCaption_Long);
                if (ageAtPickUpCaptionLong.trim().length > 0) {
                    this._ageAtPickUpCaption_Long = ageAtPickUpCaptionLong;
                }

                if (font.trim().length > 0) {
                    this._font = font;
                }
                if (textColour.trim().length > 0) {
                    this._textColour = textColour;
                }
                if (invalidTextColour.trim().length > 0) {
                    this._invalidTextColour = invalidTextColour;
                }
                if (invalidBorderColour.trim().length > 0) {
                    this._invalidBorderColour = invalidBorderColour;
                }
                if (containerBackColour.trim().length > 0) {
                    this._containerBackColour = containerBackColour;
                }
                if (containerBorderColour.trim().length > 0) {
                    this._containerBorderColour = containerBorderColour;
                }
                if (containerCornerRadius.trim().length > 0) {
                    this._containerCornerRadius = containerCornerRadius;
                }
                if (inactiveTabColour.trim().length > 0) {
                    this._inactiveTabColour = inactiveTabColour;
                }
                if ((containerBorderStyle.trim().length > 0) 
                    || (containerBorderColour.trim().length > 0)) {
                    this._containerBorderFull = containerBorderColour + " " + containerBorderStyle;
                }
                if (hasMap.trim().length > 0) {
                    this._hasMap = (hasMap == "1");
                }
                if (validationMode.trim().length > 0) {

                    switch (validationMode.trim()) {
                        case "1":
                            this._validationMode = enumValidationMode.valmode_OnPageSubmit;
                            break;

                        default:
                            this._validationMode = enumValidationMode.valmode_Immediate;
                            break;
                    }
                }
                if (multiPageMode.trim().length > 0) {

                    switch (multiPageMode.trim()) {
                        case "1":
                            this._multiPageMode = enumMultiPageMode.mpmode_Links;
                            break;

                        default:
                            this._multiPageMode = enumMultiPageMode.mpmode_Tabs;
                            break;
                    }
                }

                if (commandButtonFont.trim().length > 0) {
                    this._commandButtonFont = commandButtonFont;
                }
                if (commandButtonRadius.trim().length > 0) {
                    this._commandButtonRadius = commandButtonRadius;
                }
                if (commandButtonTextSize.trim().length > 0) {
                    this._commandButtonTextSize = commandButtonTextSize;
                    this._configuredCommandButtonTextSize = commandButtonTextSize;
                }
                if (commandButtonTextWeight.trim().length > 0) {
                    this._commandButtonTextWeight = commandButtonTextWeight;
                }
                if (primaryCommandButtonTextColour.trim().length > 0) {
                    this._primaryCommandButtonTextColour = primaryCommandButtonTextColour;
                }
                if (primaryCommandButtonBackColour.trim().length > 0) {
                    this._primaryCommandButtonBackColour = primaryCommandButtonBackColour;
                }
                if ((primaryCommandButtonBorderStyle.trim().length > 0)
                    || (primaryCommandButtonBorderColour.trim().length > 0)) {
                    this._primaryCommandButtonBorderFull = primaryCommandButtonBorderColour + " " + primaryCommandButtonBorderStyle;
                }
                if (secondaryCommandButtonTextColour.trim().length > 0) {
                    this._secondaryCommandButtonTextColour = secondaryCommandButtonTextColour;
                }
                if (secondaryCommandButtonBackColour.trim().length > 0) {
                    this._secondaryCommandButtonBackColour = secondaryCommandButtonBackColour;
                }
                if ((secondaryCommandButtonBorderStyle.trim().length > 0)
                    || (secondaryCommandButtonBorderColour.trim().length > 0)) {
                    this._secondaryCommandButtonBorderFull = secondaryCommandButtonBorderColour + " " + secondaryCommandButtonBorderStyle;
                }

                if (checkboxTickColour.trim().length > 0) {
                    this._checkboxTickColour = checkboxTickColour;
                }
                if (checkboxTickedBackColour.trim().length > 0) {
                    this._checkboxTickedBackColour = checkboxTickedBackColour;
                }
                if (checkboxUntickedBackColour.trim().length > 0) {
                    this._checkboxUntickedBackColour = checkboxUntickedBackColour;
                }
                if (checkboxBorderColour.trim().length > 0) {
                    this._checkboxBorderColour = checkboxBorderColour;
                }

                break;

            case enumAsyncLoad.Dictionary:
                this._firstTabCaption_New = this._dictionaryService.getDictionaryValue(this._component, "FirstTabCaption-New", false, "New Booking");
                this._firstTabCaption_New_Short = this._dictionaryService.getDictionaryValue(this._component, "FirstTabCaption-New", true, "New");

                this._firstTabCaption_Modify = this._dictionaryService.getDictionaryValue(this._component, "FirstTabCaption-Modify", false, "Your booking - {0}");
                this._firstTabCaption_Modify_Short = this._dictionaryService.getDictionaryValue(this._component, "FirstTabCaption-Modify", true, "{0}.");

                break;

            case enumAsyncLoad.RentalTimesIn:
                this._rentalTimesIn = this._configDataService.rentalTimesIn;
                break;
        }
        
        if (fullyLoaded) {
            //get the current BusinessEvent's data
            this.loadBusinessEvent(false);

            if ((this._locationsOut == null) || (this._locationsOut.length == 0))
                this._loadingErrorMsgs.push("No known pick up locations.");

            if ((this._locationsIn == null) || (this._locationsIn.length == 0))
                this._loadingErrorMsgs.push("No known drop off locations.");

            if ((this._vehicleTypes == null) || (this._vehicleTypes.length == 0))
                this._loadingErrorMsgs.push("No defined vehicle types.");

            if ((this._ageRanges == null) || (this._ageRanges.length == 0))
                this._loadingErrorMsgs.push("No defined ages.");

            if ((this._rentalTimesOut == null) || (this._rentalTimesOut.length == 0))
                this._loadingErrorMsgs.push("No defined rental out times.");

            if ((this._rentalTimesIn == null) || (this._rentalTimesIn.length == 0))
                this._loadingErrorMsgs.push("No defined rental in times.");
        }

        this._fullyLoaded = fullyLoaded;

        if (fullyLoaded)
            this.getScreenSize();
    }

    private loadBusinessEvent(resetBusinessEvent: boolean) {
        const millisecondsPerMinute = 60000;
        const millisecondsPerDay = 86400000;

        var offsetTodaysDate: Date = new Date((new Date()).valueOf() - ((new Date()).getTimezoneOffset() * millisecondsPerMinute));
        this._todaysDate = offsetTodaysDate.toISOString().split('T')[0];

        //get the BusinessEvent data
        this._be = this._beDataService.getBusinessEventForStep(this._currentStep, resetBusinessEvent);
        this._reference = this._be.reference;

        //get the vehicle &  promotion types
        if (resetBusinessEvent) {
            if (this._vehicleTypes.length > 0) {
                this._vehicleTypeId = this._vehicleTypes[0].value;
            }

            if (this._promoTypes.length > 0) {
                this._promotionTypeId = this._promoTypes[0].promotionTypeId;
            }
        }
        else {
            if ((this._vehicleTypeId < 0)
                && (this._be.vehicleType.vehicleTypeId > 0)) {
                this._vehicleTypeId = this._be.vehicleType.vehicleTypeId;
            }

            if ((this._promotionTypeId < 0)
                && (this._be.promotionType.promotionTypeId > 0)) {
                this._promotionTypeId = this._be.promotionType.promotionTypeId;
            }
        }

        //default to the first vehicle type, if not already defined
        if ((this._vehicleTypeId < 0)
            && (this._vehicleTypes.length > 0)) {
            this._vehicleTypeId = this._vehicleTypes[0].value;
        }

        //select the first promo type as the default
        if ((this._promotionTypeId < 0)
            && (this._promoTypes.length > 0)) {
            this._promotionTypeId = this._promoTypes[0].promotionTypeId;
        }

        //get the LocationOut value, or default to the 'Select a location...' option if required
        //if (this._be.locationOut.locationId > 0) {
        //    this._locationOutId = this._be.locationOut.locationId;
        //}
        //else {
        //    this._locationOutId = -1;
        //}

        var locOut: SelectItem = <SelectItem>this._locationsOutx.find(x => x.value.locationId == this._be.locationOut.locationId);
        if (locOut != null)
            this._locationOutx = locOut.value;
        else {
            if (this._locationsOutx.length == 1) {
                var locOutOnlyOne: SelectItem = <SelectItem>this._locationsOutx[0].value;
                this._locationOutx = locOutOnlyOne.value;
            }
            else
                this._locationOutx = <Location>{ locationId: -1 };
        }

        //get the LocationIn value, or default to the 'Select a location...' option if required
        //if (this._be.locationIn.locationId > 0) {
        //    this._locationInId = this._be.locationIn.locationId;
        //}
        //else {
        //    this._locationInId = -1;
        //}
        var locIn: SelectItem = <SelectItem>this._locationsInx.find(x => x.value.locationId == this._be.locationIn.locationId);
        if (locIn != null)
            this._locationInx = locIn.value;
        else {
            if (this._locationsInx.length == 1) {
                var locInOnlyOne: SelectItem = <SelectItem>this._locationsInx[0].value;
                this._locationInx = locInOnlyOne.value;
            }
            else
                this._locationInx = <Location>{ locationId: -1 };
        }

        //this._dropOffDifferent = (this._locationOutId != this._locationInId);
        this._dropOffDifferent = ((this._locationOutx == null ? -1 : this._locationOutx.locationId) != (this._locationInx == null ? -1 : this._locationInx.locationId));

        //get the DateTimeOut values, if it is set
        if (this._be.dateTimeOut != null) {
            var offsetDateTimeOut: Date = new Date(this._be.dateTimeOut.valueOf() - (this._be.dateTimeOut.getTimezoneOffset() * millisecondsPerMinute));
            var isoDateTimeOut = offsetDateTimeOut.toISOString();

            this._dateOut = isoDateTimeOut.split('T')[0];

            let isoTimeOut: string = isoDateTimeOut.split('T')[1];
            let timeOut: string = isoTimeOut.split('Z')[0];
            this._timeOut = this.getNearestValidTime(timeOut.split(':')[0] + ":" + timeOut.split(':')[1], enumRentalEdge.Out);
        }
        else {
            this._dateOut = "";
            let dfltDateOutOffset: string = this._configDataService.getClientConfig(enumClientConfig.cconf_DefaultDateOutOffset);
            
            if((dfltDateOutOffset.length > 0)
                && (!isNaN(Number(dfltDateOutOffset)))) {

                var dfltDateOut: Date = new Date();
                dfltDateOut.setDate(offsetTodaysDate.getDate() + Number(dfltDateOutOffset));
                this._dateOut = dfltDateOut.toISOString().split('T')[0];
            }
            this._timeOut = this.getNearestValidTime(this._configDataService.getClientConfig(enumClientConfig.cconf_DefaultTimeOut, "12:00"), enumRentalEdge.Out);
        }

        //get the DateTimeIn values, if it is set
        if (this._be.dateTimeIn != null) {
            var offsetDateTimeIn: Date = new Date(this._be.dateTimeIn.valueOf() - (this._be.dateTimeIn.getTimezoneOffset() * millisecondsPerMinute));
            var isoDateTimeIn = offsetDateTimeIn.toISOString();

            this._dateIn = isoDateTimeIn.split('T')[0];

            let isoTimeIn: string = isoDateTimeIn.split('T')[1];
            let timeIn: string = isoTimeIn.split('Z')[0];
            this._timeIn = this.getNearestValidTime(timeIn.split(':')[0] + ":" + timeIn.split(':')[1], enumRentalEdge.In);
        }
        else {
            this._dateIn = "";
            let dfltDuration: string = this._configDataService.getClientConfig(enumClientConfig.cconf_DefaultDuration);
            if ((dfltDuration.length > 0)
                && (!isNaN(Number(dfltDuration)))) {

                var dateTimeOut = this.constructDateTime(enumRentalEdge.Out);
                if (dateTimeOut != null) {
                    let dfltDateIn: Date = new Date(dateTimeOut.valueOf() + (Number(dfltDuration) * millisecondsPerDay));

                    this._dateIn = dfltDateIn.toISOString().split('T')[0];
                }
            }
            this._timeIn = this.getNearestValidTime(this._configDataService.getClientConfig(enumClientConfig.cconf_DefaultTimeIn, "12:00"), enumRentalEdge.In);
        }

        //get the AgeRange value, or default to the 'Select an age range...' option if required
        if (this._be.ageRange.ageRangeId > 0) {
            this._ageRangeId = this._be.ageRange.ageRangeId;
        }
        else {
            this._ageRangeId = -1;
        }

        //promo type done above
        if ((this._be.eventMode == enumBusinessEventMode.beMode_Create)
            && (this._query_PromoCode.length > 0)
            && (!resetBusinessEvent)) {

            this._promoCode = this._query_PromoCode;
            this._promotionTypeId = 2;
        }
        else
            this._promoCode = this._be.promoCode;

        //delivery/collection
        this._hasDelivery = this._be.hasDelivery;
        this._deliveryAddress = this._be.deliveryAddress;
        this._hasCollection = this._be.hasCollection;
        this._collectionAddress = this._be.collectionAddress;

        let beRef: string = "";
        if (this._be.eventMode != enumBusinessEventMode.beMode_Create) 
            beRef = (this._be.reference == null ? "" : this._be.reference);
        //this._firstTabCaption = (beRef.length == 0 ? "New Booking" : "Your booking - " + beRef);
        //this._firstTabCaptionShort = (beRef.length == 0 ? "New" : beRef);
        this._firstTabCaption = (beRef.length == 0 ? this._firstTabCaption_New : this._dictionaryService.stringFormat(this._firstTabCaption_Modify, beRef));
        this._firstTabCaptionShort = (beRef.length == 0 ? this._firstTabCaption_New_Short : this._dictionaryService.stringFormat(this._firstTabCaption_Modify_Short, beRef));
        this._clearButtonCaption = (this._be.eventMode == enumBusinessEventMode.beMode_Create ? "Clear" : "New booking");

        //ensure we're positioned at the top of the page
        window.scroll(0, 0);

        if (resetBusinessEvent) {
            this._doValidation = (this._validationMode == enumValidationMode.valmode_Immediate);
        }
        this.validateForm();
        this._hasChanged = false;
    }

    private loadOTAVehRetResRs() {
        const millisecondsPerMinute = 60000;
        const millisecondsPerDay = 86400000;

        var offsetTodaysDate: Date = new Date((new Date()).valueOf() - ((new Date()).getTimezoneOffset() * millisecondsPerMinute));

        //reset the BusinessEvent data
        this._be = this._beDataService.getBusinessEventForStep(this._currentStep, true);
        this._be.otaVehRetResRS = this._otaResponse.otA_VehRetResRS;
        //
        //save the Itinerary data
        //
        this._be.eventMode = (this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation.reservationStatus == "Reservation" ? enumBusinessEventMode.beMode_Edit : enumBusinessEventMode.beMode_View);
        this._be.reference = this._searchBookingReference;

        //get the vehicle &  promotion types
        this._be.vehicleType.vehicleTypeId = -1;
        if (this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation.vehSegmentCore.vehicle.vehType.vehicleCategory > 0) {
            this._be.vehicleType.vehicleTypeId =  OTA_VehType.eraVehicleTypeFromCategory(this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation.vehSegmentCore.vehicle.vehType.vehicleCategory);

            //check the vehicle type is in our list of vehicle types
            var vehType = this._vehicleTypes.find(vt => (vt.value == this._be.vehicleType.vehicleTypeId));
            if (vehType == null)
                this._be.vehicleType.vehicleTypeId = -1;
        }

        this._be.promotionType.promotionTypeId = -1;
        if (this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation.vehSegmentCore.rentalRate.rateQualifier.corpDiscountNmbr.trim().length > 0) {
            this._be.promotionType.promotionTypeId = 1
            this._be.promoCode = this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation.vehSegmentCore.rentalRate.rateQualifier.corpDiscountNmbr;
        }
        if (this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation.vehSegmentCore.rentalRate.rateQualifier.promotionCode.trim().length > 0) {
            this._be.promotionType.promotionTypeId = 2;
            this._be.promoCode = this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation.vehSegmentCore.rentalRate.rateQualifier.promotionCode;
        }
        //check the promotion type is in our list of promotion types
        var promoType = this._promoTypes.find(pt => (pt.promotionTypeId == this._be.promotionType.promotionTypeId));
        if (promoType == null)
            this._be.promotionType.promotionTypeId = -1;

        //default to the first vehicle type, if not already defined
        if ((this._be.vehicleType.vehicleTypeId < 0)
            && (this._vehicleTypes.length > 0)) {
            this._be.vehicleType.vehicleTypeId = this._vehicleTypes[0].value;
        }

        //select the first promo type as the default
        if ((this._be.promotionType.promotionTypeId < 0)
            && (this._promoTypes.length > 0)) {
            this._be.promotionType.promotionTypeId = this._promoTypes[0].promotionTypeId;
        }

        //get the LocationOut value
        this._be.locationOut = this.getLocationByCode(this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation.vehSegmentCore.vehRentalCore.pickUpLocation.locationCode, enumRentalEdge.Out);

        //get the LocationIn value
        this._be.locationIn = this.getLocationByCode(this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation.vehSegmentCore.vehRentalCore.returnLocation.locationCode, enumRentalEdge.In);

        //get the DateTimeOut values
        if (this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation.vehSegmentCore.vehRentalCore.pickUpDateTime != null) {
            this._be.dateTimeOut = new Date(this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation.vehSegmentCore.vehRentalCore.pickUpDateTime.toString());
            var isoDateTimeOut = this._be.dateTimeOut.toISOString();
            this._dateOut = isoDateTimeOut.split('T')[0];

            let isoTimeOut: string = isoDateTimeOut.split('T')[1];
            let timeOut: string = isoTimeOut.split('Z')[0];

            if (this._be.eventMode == enumBusinessEventMode.beMode_View) {
                this._timeOut = timeOut.split(':')[0] + ":" + timeOut.split(':')[1];
            }
            else {
                this._timeOut = this.getNearestValidTime(timeOut.split(':')[0] + ":" + timeOut.split(':')[1], enumRentalEdge.Out);
            }
        }
        else {
            this._dateOut = "";
            let dfltDateOutOffset: string = this._configDataService.getClientConfig(enumClientConfig.cconf_DefaultDateOutOffset);

            if ((dfltDateOutOffset.length > 0)
                && (!isNaN(Number(dfltDateOutOffset)))) {

                var dfltDateOut: Date = new Date();
                dfltDateOut.setDate(offsetTodaysDate.getDate() + Number(dfltDateOutOffset));
                this._dateOut = dfltDateOut.toISOString().split('T')[0];
            }
            this._timeOut = this.getNearestValidTime(this._configDataService.getClientConfig(enumClientConfig.cconf_DefaultTimeOut, "12:00"), enumRentalEdge.Out);
        }
        this._be.dateTimeOut = this.constructDateTime(enumRentalEdge.Out);

        //get the DateTimeIn values, if it is set
        if (this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation.vehSegmentCore.vehRentalCore.returnDateTime != null) {
            this._be.dateTimeIn = new Date(this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation.vehSegmentCore.vehRentalCore.returnDateTime.toString());
            var isoDateTimeIn = this._be.dateTimeIn.toISOString();
            this._dateIn = isoDateTimeIn.split('T')[0];

            let isoTimeIn: string = isoDateTimeIn.split('T')[1];
            let timeIn: string = isoTimeIn.split('Z')[0];

            if (this._be.eventMode == enumBusinessEventMode.beMode_View) {
                this._timeIn = timeIn.split(':')[0] + ":" + timeIn.split(':')[1];
            }
            else {
                this._timeIn = this.getNearestValidTime(timeIn.split(':')[0] + ":" + timeIn.split(':')[1], enumRentalEdge.In);
            }
        }
        else {
            this._dateIn = "";
            let dfltDuration: string = this._configDataService.getClientConfig(enumClientConfig.cconf_DefaultDuration);
            if ((dfltDuration.length > 0)
                && (!isNaN(Number(dfltDuration)))) {

                var dateTimeOut = this.constructDateTime(enumRentalEdge.Out);
                if (dateTimeOut != null) {
                    let dfltDateIn: Date = new Date(dateTimeOut.valueOf() + (Number(dfltDuration) * millisecondsPerDay));

                    this._dateIn = dfltDateIn.toISOString().split('T')[0];
                }
            }
            this._timeIn = this.getNearestValidTime(this._configDataService.getClientConfig(enumClientConfig.cconf_DefaultTimeIn, "12:00"), enumRentalEdge.In);
        }
        this._be.dateTimeIn = this.constructDateTime(enumRentalEdge.In);

        //get the AgeRange value, or default to the 'Select an age range...' option if required
        if (this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation.customer.primary.birthDate != null) {
            let birthDate = new Date(this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation.customer.primary.birthDate.toString());
            this._be.ageRange.ageRangeId = this.getAgeRangeFromBirthDate(birthDate);
        }
        else {
            this._be.ageRange.ageRangeId = -1;
        }
        this._be.ageRange.ageApplied = this._be.ageRange.ageRangeId;

        this._be.hasDelivery = ((this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation.vehSegmentInfo.pricedOffLocServices != null) 
            && (this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation.vehSegmentInfo.pricedOffLocServices.filter(ols => ols.offLocService.type == "VehDelivery").length > 0));
        let deliveryAddress: string = "";
        if (this._be.hasDelivery) {
            this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation.vehSegmentInfo.pricedOffLocServices.filter(ols => ols.offLocService.type == "VehDelivery")[0].offLocService.address.addressLines.forEach(function (addrLine) {
                deliveryAddress = deliveryAddress
                    + (deliveryAddress.length > 0 ? "\n" : "")
                    + addrLine;
            });
        }
        this._be.deliveryAddress = deliveryAddress;

        this._be.hasCollection = ((this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation.vehSegmentInfo.pricedOffLocServices != null)
            && (this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation.vehSegmentInfo.pricedOffLocServices.filter(ols => ols.offLocService.type == "VehCollection").length > 0));
        let collectionAddress: string = "";
        if (this._be.hasCollection) {
            this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation.vehSegmentInfo.pricedOffLocServices.filter(ols => ols.offLocService.type == "VehCollection")[0].offLocService.address.addressLines.forEach(function (addrLine) {
                collectionAddress = collectionAddress
                    + (collectionAddress.length > 0 ? "\n" : "")
                    + addrLine;
            });
        }
        this._be.collectionAddress = collectionAddress;
        this._be.vehicleSelected = true;

        this._beDataService.setBusinessEventForStep(this._currentStep, this._be);

        //
        //save the Vehicle selection data
        //
        if (this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation.vehSegmentCore != null) {
            this._be.vehicleGroupReserved = this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation.vehSegmentCore.vehicle.code;
            this._be.vehicleSelected = true;
            this._be.otaVehAvail = new OTA_VehAvail();
            this._be.otaVehAvail.vehAvailCore.status = "Available";
            this._be.otaVehAvail.vehAvailCore.vehicle = this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation.vehSegmentCore.vehicle;
            this._be.otaVehAvail.vehAvailCore.rentalRate = this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation.vehSegmentCore.rentalRate;
            this._be.otaVehAvail.vehAvailCore.totalCharge = this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation.vehSegmentCore.totalCharge;
            this._be.otaVehAvail.vehAvailCore.pricedEquips = this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation.vehSegmentCore.pricedEquips;
            this._be.otaVehAvail.vehAvailCore.fees = this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation.vehSegmentCore.fees;
        }
        this._beDataService.setBusinessEventForStep(BEWorkflowSteps.beVehicleSelection, this._be);

        //
        //save the Extras selection data
        //
        this._be.refresh = false;
        this._be.otaVehAvail.vehAvailCore.pricedEquips = this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation.vehSegmentCore.pricedEquips;
        this._be.otaVehAvail.vehAvailCore.pricedEquips.filter(eq => eq.charge.includedInEstTotalInd).forEach(function (eq) {
            eq.requestedCount = eq.equipment.quantity;
        });

        this._be.otaVehAvail.vehAvailInfo.pricedCoverages = this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation.vehSegmentInfo.pricedCoverages;
        if (this._be.otaVehAvail.vehAvailInfo.pricedCoverages.length > 0) {
            let useDflt: boolean = true;

            //deselect all coverages
            this._be.otaVehAvail.vehAvailInfo.pricedCoverages.forEach(function (cvr) {
                cvr.selected = false;

                if ((cvr.charge.includedInEstTotalInd) && (!cvr.charge.includedInRate)) {
                    cvr.selected = true;
                    useDflt = false;
                }
            });

            if (useDflt) {
                this._be.otaVehAvail.vehAvailInfo.pricedCoverages.filter(cvr => ((cvr.charge.includedInEstTotalInd) && (cvr.charge.includedInRate))).forEach(function (cvr) {
                    cvr.selected = true;
                });
            }
        }

        this._beDataService.setBusinessEventForStep(BEWorkflowSteps.beExtras, this._be);

        //
        //save the Review selection data
        //
        this._be.rentingentity.firstName = this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation.customer.primary.personName.givenName;
        this._be.rentingentity.principalName = this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation.customer.primary.personName.surname;
        this._be.rentingentity.renterId = this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation.customer.primary.customerId;
        this._be.flightNumber = this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation.vehSegmentInfo.arrivalDetails.operatingCompany.code
            + this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation.vehSegmentInfo.arrivalDetails.number;

        if (this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation.customer.primary.birthDate != null) {
            this._be.rentingentity.dateofBirth = this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation.customer.primary.birthDate;
        }

        //save the email Identification
        if (this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation.customer.primary.emails.length > 0) {
            let newEmailIdent: Identification = new Identification();
            newEmailIdent.membershipNumber = this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation.customer.primary.emails[0].address;
            newEmailIdent.identStatus = enumIdentStatus.idStatus_Valid;
            newEmailIdent.identType = enumIdentType.idType_Email;
            //newEmailIdent.allowNotification = this._emailSubscription;
            this._be.rentingentity.identList.push(newEmailIdent);
        }

        //save the Documents
        if ((this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation.customer.primary.documents != null)
            && (this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation.customer.primary.documents.length > 0)) {
            this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation.customer.primary.documents.forEach((doc) => {
                var dType: number = +doc.docType;

                if (dType == 4)
                {
                    //4 = DL in OTA
                    let newDoc: Identification = new Identification();
                    newDoc.membershipNumber = doc.docID;
                    newDoc.identStatus = enumIdentStatus.idStatus_Valid;
                    newDoc.identType = enumIdentType.idType_DriversLicense;

                    if (doc.expireDate != null) {
                        newDoc.expiry = doc.expireDate;
                    }

                    this._be.rentingentity.identList.push(newDoc);
                }
            });
        }

        //save the phone
        if (this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation.customer.primary.telephones.filter(tel => (tel.phoneTechType == "1")).length > 0) {
            //create a new phone object
            var newPhone: Phone = new Phone();
            newPhone.phoneNumber = this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation.customer.primary.telephones[0].phoneNumber;
            newPhone.phoneType = enumPhoneType.phnTypeContacts;
            this._be.rentingentity.phoneList.push(newPhone);
        }

        //save the address
        if (this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation.customer.primary.addresses.length > 0) {
            //create a new address object
            var newAddress: Address = new Address();
            newAddress.addressLine1 = this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation.customer.primary.addresses[0].addressLines[0];
            newAddress.city = this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation.customer.primary.addresses[0].cityName;
            newAddress.state = this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation.customer.primary.addresses[0].stateProv;
            newAddress.zipCode = this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation.customer.primary.addresses[0].postalCode;
            newAddress.addressTypeId = enumAddressType.addrTypeLocal;
            this._be.rentingentity.address = newAddress;
        }


        if (this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation.reservationStatus == "Reservation") {
            this._beDataService.setBusinessEventForStep(BEWorkflowSteps.beReview, this._be, 0, false);

            //navigate to the Review page
            this.navigateTo("beReview");
        }
        else {
            this._beDataService.setBusinessEventForStep(BEWorkflowSteps.beReview, this._be, 0, true);

            //navigate to the Confirmation page
            this.navigateTo("beConfirmation");
        }
    }

    //save the entered form values to the BusinessEvent object
    private save(): boolean {
        this._doValidation = true;
        this.validateForm();

        if (this._hasError)
            return false;

        this._be.vehicleSelected = ((this._be.vehicleSelected) && (!this._hasChanged));
        this._be.vehicleType.vehicleTypeId = this._vehicleTypeId;

        //this._be.locationOut = this.getLocationById(this._locationOutId, enumRentalEdge.Out);
        this._be.locationOut = this.getLocationById((this._locationOutx == null ? -1 : this._locationOutx.locationId), enumRentalEdge.Out);

        if (this._dropOffDifferent)
            //this._be.locationIn = this.getLocationById(this._locationInId, enumRentalEdge.In);
            this._be.locationIn = this.getLocationById((this._locationInx == null ? -1 : this._locationInx.locationId), enumRentalEdge.In);
        else
            this._be.locationIn = this._be.locationOut;

        this._be.dateTimeOut = this.constructDateTime(enumRentalEdge.Out);
        this._be.dateTimeIn = this.constructDateTime(enumRentalEdge.In);

        this._be.ageRange.ageRangeId = this._ageRangeId;
        this._be.ageRange.ageApplied = this._ageRangeId;

        this._be.promotionType.promotionTypeId = this._promotionTypeId;
        this._be.promoCode = this._promoCode;

        this._be.hasDelivery = this._hasDelivery;
        this._be.deliveryAddress = this._deliveryAddress;
        this._be.hasCollection = this._hasCollection;
        this._be.collectionAddress = this._collectionAddress;

        this._be.reference = this._reference;
        this._be.rentalChanged = (this._be.rentalChanged || this._hasChanged);

        this._beDataService.setBusinessEventForStep(this._currentStep, this._be);

        return true;
    }

    private clear(forceBEReload: boolean = false) {
        //reset the BusinessEvent
        if ((this._hasChanged) || (!this._beDataService.isVehicleSelectionDisabled)) {

            //clear the Dialog object's array of DialogButtons
            this._dialog.buttons = [];

            //apply the required buttons to the Dialog object
            var btnYes: DialogButton = new DialogButton();
            btnYes.label = "Yes";
            btnYes.buttonType = enumDialogButtonType.dlgParam_Yes;
            this._dialog.buttons.push(btnYes);

            var btnNo: DialogButton = new DialogButton();
            btnNo.label = "No";
            btnNo.buttonType = enumDialogButtonType.dlgParam_No;
            this._dialog.buttons.push(btnNo);

            this._confirmationService.confirm({
                message: 'Are you sure you want to clear the entered values?',
                accept: () => {
                    switch (this._dialog.buttonPressed.buttonType) {
                        case enumDialogButtonType.dlgParam_Yes:
                            this.loadBusinessEvent(true);
                            this._entryMode = enumEntryMode.Add;
                            break;
                        case enumDialogButtonType.dlgParam_No:
                            break;
                    }
                },
            });
        }
        else {
            if (forceBEReload)
                this.loadBusinessEvent(true);
            this._entryMode = enumEntryMode.Add;
        }
    }

    private clearSearch() {
        //reset the search parameters
        this._searchBookingReference = "";
        this._searchEmail = "";
        this._doSearchValidation = (this._validationMode == enumValidationMode.valmode_Immediate);
        this.validateSearchForm();
    }

    private doSearch() {
        //search for a reservation given the booking reference; then validate using the email address
        this._doSearchValidation = true;
        this.validateSearchForm();

        if (this._hasSearchError)
            return false;

        //construct the OTA Request object for the current business event
        let otaReq: OTA_Request = this.createOTARequest();

        //show spinner
        this._searching = true;

        //get the OTA Reservation for the entered Booking Ref
        this._httpClient.get<OTA_Response>(this._baseUrl + 'api/OTAData/OTARequest?'
            + '&otaReqJSON=' + JSON.stringify(otaReq)).subscribe(result => {
                this._otaResponse = result;

                this._searching = false;
                this.loadSearchResponse();
            }, error => console.error(error));
    }

    private createOTARequest(): OTA_Request {
        //construct the OTA Request object for the entered search
        let otaReq: OTA_Request = new OTA_Request(enumRequestType.reqType_VehRetRes);

        try {
            otaReq.otA_VehRetResRQ.vehRetResRQCore.uniqueID.uniqueID = this._searchBookingReference;
            //otaReq.otA_VehRetResRQ.vehRetResRQCore.uniqueID.type = "14";
        }
        catch (e) {
            console.log(e);
        }

        return otaReq;
    }

    private loadSearchResponse() {
        let errors: OTA_Error[] = new Array<OTA_Error>();

        if (this._otaResponse == null) {
            let otaError: OTA_Error = new OTA_Error();
            otaError.shortText = "No response received";
            errors.push(otaError);
        }
        else {
            if ((this._otaResponse.callStatus != null)
                && (this._otaResponse.callStatus.code != enumCallStatus.csStatus_OK)) {
                let otaError: OTA_Error = new OTA_Error();
                otaError.shortText = "Error - " + this._otaResponse.callStatus.code.toString();
                //TODO specific messages per CallStatus code?
                errors.push(otaError);
            }
            else {
                if ((this._otaResponse.otA_VehRetResRS.errors != null)
                    && (this._otaResponse.otA_VehRetResRS.errors.length > 0)) {
                    errors = this._otaResponse.otA_VehRetResRS.errors;
                }
                else {
                    //validate that the given searchEmail is in the returned booking
                    let emailMatches: boolean = false;

                    if ((this._otaResponse.otA_VehRetResRS.vehRetResRSCore != null)
                        && (this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation != null)
                        && (this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation.customer != null)
                        && (this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation.customer.primary != null)
                        && (this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation.customer.primary.emails != null)) {

                        //see if the given email address belongs to the customer in the returned booking
                        var eml = this._otaResponse.otA_VehRetResRS.vehRetResRSCore.vehReservation.customer.primary.emails.find(e => (e.address.trim().toUpperCase() == this._searchEmail.trim().toUpperCase()));
                        emailMatches = (eml != null);
                    }

                    if (!emailMatches) {
                        let otaError: OTA_Error = new OTA_Error();
                        otaError.shortText = "No bookings match the entered Booking Reference and Email Address";
                        errors.push(otaError);
                    }
                }
            }
        }

        if (errors.length > 0) {
            //errors, so inform the user, and take them back to the previous page
            let msg: string = "";

            if (errors.length > 1) {
                msg = "Unable to find any matching booking.<BR/><ul>";

                for (var otaErr in errors) {
                    msg = msg + "<li>" + errors[otaErr].shortText + "</li>";
                }
                msg = msg + "</ul>";
            }
            else {
                msg = errors[0].shortText;
            }

            //clear the Dialog object's array of DialogButtons
            this._dialog.buttons = [];

            //apply the required buttons to the Dialog object
            var btnOK: DialogButton = new DialogButton();
            btnOK.label = "OK";
            btnOK.buttonType = enumDialogButtonType.dlgParam_OK;
            this._dialog.buttons.push(btnOK);

            this._confirmationService.confirm({
                message: msg,
                accept: () => {},
            });
        }
        else {
            //no errors, so load the retrieved booking
            this.loadOTAVehRetResRs();
        }
    }

    private tabClick(tabNumber: number) {
        //activate the given tab
        let newEntryMode: enumEntryMode = enumEntryMode.Add;

        if (tabNumber == this._entryMode)
            return;

        switch (tabNumber) {
            case enumEntryMode.Add:
                break;

            case enumEntryMode.Search:
                newEntryMode = enumEntryMode.Search;
                this.clearSearch();
                break;
        }

        this._entryMode = newEntryMode;
    }

    //
    //navigation methods
    //
    private goToNext() {
        if (this.save())
            //navigate to the next page
            this.navigateTo(this._nextStep);
    }

    private navigateTo(step: string) {
        //navigate to the given page
        if (step.trim().length > 0)
            this._router.navigate(['/' + step]);
    }

    //
    //validation methods
    //
    private validateLocationOut() {
        //refresh the map markers (currently selected location is given a different icon to others)
        this.refreshMap();

        //validate the form
        this.validateForm();
    }

    private validateForm() {
        var dateTimeOut = this.constructDateTime(enumRentalEdge.Out);
        var dateTimeIn = this.constructDateTime(enumRentalEdge.In);
        var now = new Date();

        this._validationErrorMsgs.length = 0;

        //Post-process entered values if required
        if (this._promoCode != null)
            this._promoCode = this._promoCode.trim();

        //if (!this._dropOffDifferent) {
        //    let locInId: number = -1;

        //    if (this._locationOutId > 0) {
        //        //check if the selected LocationOut is in our list of LocationIns
        //        //and select it as the LocastionIn if the dropOff location is the same as the pickup location
        //        let locIn: Location = <Location>this._locationsOut.find(x => x.locationId == this._locationOutId);
        //        if (locIn != null) {
        //            locInId = this._locationOutId;
        //        }
        //    }

        //    this._locationInId = locInId;
        //}

        if (!this._dropOffDifferent) {
            //check if the selected LocationOut is in our list of LocationIns
            //and select it as the LocastionIn if the dropOff location is the same as the pickup location
            var locIn: SelectItem = <SelectItem>this._locationsInx.find(x => x.value.locationId == (this._locationOutx == null ? -1 : this._locationOutx.locationId));
            if (locIn != null)
                this._locationInx = locIn.value;
            else
                this._locationInx = <Location>{ locationId: -1 };
        }

        //Validate each individual entry

        //the VehicleType must be selected
        this._hasVehicleTypeError = (this._vehicleTypeId == -1);
        //the LocationOut must be selected
        //this._hasLocationOutError = (this._locationOutId == -1);
        this._hasLocationOutError = ((this._locationOutx == null) || (this._locationOutx.locationId <= 0));
        //the LocationIn must be selected if different from the LocationOut
        //this._hasLocationInError = ((this._locationInId == -1)
        //    && (this._dropOffDifferent));
        this._hasLocationInError = (((this._locationInx == null) || (this._locationInx.locationId <= 0))
            && (this._dropOffDifferent));
        //the date/time out must be entered
        this._hasDateTimeOutError = ((dateTimeOut == null)
            || (dateTimeOut <= now));
        //the date/time in must be entered, and after the date/time out
        this._hasDateTimeInError = ((dateTimeOut != null)
            && ((dateTimeIn == null) || (dateTimeIn <= dateTimeOut)));
        //the AgeRange must be selected
        this._hasAgeRangeError = (this._ageRangeId == -1);
        //the PromotionType must be selected if a Promo is entered
        this._hasPromoCodeError = ((this._promoCode != null)
            && (this._promoCode.length > 0)
            && (this._promotionTypeId == -1));

        //contruct the date/time out for comparison with the original date/time out
        var isoDateTimeOut = "";
        if (dateTimeOut != null) {
            isoDateTimeOut = dateTimeOut.toISOString();
        }
        var savedISODateTimeOut = "";
        if (this._be.dateTimeOut != null)
            savedISODateTimeOut = this._be.dateTimeOut.toISOString();

        //contruct the date/time in for comparison with the original date/time in
        var isoDateTimeIn = "";
        if (dateTimeIn != null)
            isoDateTimeIn = dateTimeIn.toISOString();
        var savedISODateTimeIn = "";
        if (this._be.dateTimeIn != null)
            savedISODateTimeIn = this._be.dateTimeIn.toISOString();

        //check if any parameter has been changed from the original value
        this._hasChanged = ((this._vehicleTypeId != this._be.vehicleType.vehicleTypeId)
            || ((this._locationOutx == null ? -1 : this._locationOutx.locationId) != this._be.locationOut.locationId)
            || (((this._locationInx == null ? -1 : this._locationInx.locationId) != this._be.locationIn.locationId) && (this._dropOffDifferent))
            || (((this._locationOutx == null ? -1 : this._locationOutx.locationId) != this._be.locationIn.locationId) && (!this._dropOffDifferent))
            //|| (this._locationOutId != this._be.locationOut.locationId)
            //|| ((this._locationInId != this._be.locationIn.locationId) && (this._dropOffDifferent))
            //|| ((this._locationOutId != this._be.locationIn.locationId) && (!this._dropOffDifferent))
            || (isoDateTimeOut != savedISODateTimeOut)
            || (isoDateTimeIn != savedISODateTimeIn)
            || (this._ageRangeId != this._be.ageRange.ageRangeId)
            || (this._promotionTypeId != this._be.promotionType.promotionTypeId)
            || (this._promoCode != this._be.promoCode)
            || (this._hasDelivery != this._be.hasDelivery)
            || ((this._deliveryAddress == null ? "" : this._deliveryAddress) != (this._be.deliveryAddress == null ? "" : this._be.deliveryAddress))
            || (this._hasCollection != this._be.hasCollection)
            || ((this._collectionAddress == null ? "" : this._collectionAddress) != (this._be.collectionAddress == null ? "" : this._be.collectionAddress)));
        this._beDataService.changeStep(this._currentStep, this._hasChanged);

        //check if the form is good to be submitted
        this._hasError = ((this._nextStep.length == 0)
            || (this._hasVehicleTypeError)
            || (this._hasLocationOutError)
            || (this._hasLocationInError)
            || (this._hasDateTimeOutError)
            || (this._hasDateTimeInError)
            || (this._hasAgeRangeError)
            || (this._hasPromoCodeError));
        this._hasSubmitError = (this._hasError && (this._validationMode == enumValidationMode.valmode_Immediate));

        this._locationOutTextColour = (this._hasLocationOutError && this._doValidation) ? this._invalidTextColour : this._textColour;
        this._locationOutBorderColour = (this._hasLocationOutError && this._doValidation) ? this._invalidBorderColour : "";
        this._locationInTextColour = (this._hasLocationInError && this._doValidation) ? this._invalidTextColour : this._textColour;
        this._locationInBorderColour = (this._hasLocationInError && this._doValidation) ? this._invalidBorderColour : "";

        this._dateTimeOutTextColour = (this._hasDateTimeOutError && this._doValidation) ? this._invalidTextColour : this._textColour;
        this._dateTimeOutBorderColour = (this._hasDateTimeOutError && this._doValidation) ? this._invalidBorderColour : "";
        this._dateTimeInTextColour = (this._hasDateTimeInError && this._doValidation) ? this._invalidTextColour : this._textColour;
        this._dateTimeInBorderColour = (this._hasDateTimeInError && this._doValidation) ? this._invalidBorderColour : "";

        this._ageRangeTextColour = (this._hasAgeRangeError && this._doValidation) ? this._invalidTextColour : this._textColour;
        this._ageRangeBorderColour = (this._hasAgeRangeError && this._doValidation) ? this._invalidBorderColour : "";

        if (this._hasVehicleTypeError)
            this._validationErrorMsgs.push("Vehicle type");
        if (this._hasLocationOutError)
            this._validationErrorMsgs.push("Pick up location");
        if (this._hasLocationInError)
            this._validationErrorMsgs.push("Drop off location");
        if (this._hasDateTimeOutError)
            this._validationErrorMsgs.push("Pickup Date/Time");
        if (this._hasDateTimeInError)
            this._validationErrorMsgs.push("Drop off Date/Time");
        if (this._hasAgeRangeError)
            this._validationErrorMsgs.push("Age");
        if (this._hasPromoCodeError)
            this._validationErrorMsgs.push("Promo Code");
    }

    private validateSearchForm() {
        //Post-process entered values if required
        if (this._searchBookingReference != null)
            this._searchBookingReference = this._searchBookingReference.trim();
        if (this._searchEmail != null)
            this._searchEmail = this._searchEmail.trim();

        this._searchValidationErrorMsgs.length = 0;

        //Validate each individual entry

        //the BookingRef must be entered
        this._hasSearchBookingRefError = ((this._searchBookingReference == null)
            || (this._searchBookingReference.length == 0));
        this._hasSearchEmailRefError = ((this._searchEmail == null)
            || (this._searchEmail.length == 0)
            || (!this.validateEmail(this._searchEmail)));

        //check if the search is good to be submitted
        this._hasSearchError = ((this._hasSearchBookingRefError)
            || (this._hasSearchEmailRefError));
        this._hasSearchSubmitError = (this._hasSearchError && (this._validationMode == enumValidationMode.valmode_Immediate));

        this._bookingRefTextColour = (this._hasSearchBookingRefError && this._doSearchValidation) ? this._invalidTextColour : this._textColour;
        this._bookingRefBorderColour = (this._hasSearchBookingRefError && this._doSearchValidation) ? this._invalidBorderColour : "";
        this._emailRefTextColour = (this._hasSearchEmailRefError && this._doSearchValidation) ? this._invalidTextColour : this._textColour;
        this._emailRefBorderColour = (this._hasSearchEmailRefError && this._doSearchValidation) ? this._invalidBorderColour : "";

        if (this._hasSearchBookingRefError)
            this._searchValidationErrorMsgs.push("Booking Reference");
        if (this._hasSearchEmailRefError)
            this._searchValidationErrorMsgs.push("Email Address");
    }

    private validateEmail(eml: string): boolean {
        var EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (!EMAIL_REGEXP.test(eml)) {
            return false;
        }
        return true;
    }

    //
    //helper methods
    //
    //construct the DateTime value fom the entered Date and Time, if possible
    private constructDateTime(edge: enumRentalEdge): any {
        var dateTime;
        var date: string = "";
        var time: string = "";

        switch (edge) {
            case enumRentalEdge.Out:
                date = this._dateOut;
                time = this._timeOut;
                break;

            case enumRentalEdge.In:
                date = this._dateIn;
                time = this._timeIn;
                break;
        }

        if (((date != null) && (date.length > 0))
            && ((time != null) && (time.length > 0))) {

            dateTime = new Date(date + "T" + time);
        }

        return dateTime;
    }

    private getLocationById(locationId: number, edge: enumRentalEdge): Location {
        var loc: Location = <Location>this._locationsOut.find(x => x.locationId == locationId);
        return loc;
    }

    private getLocationByCode(locationCode: string, edge: enumRentalEdge): Location {
        var loc: Location = <Location>this._locationsOut.find(x => x.code.trim().toUpperCase() == locationCode.trim().toUpperCase());
        return loc;
    }

    private getAgeRangeFromBirthDate(birthDate?: Date): number {
        let ageRangeId: number = -1;

        try {
            if ((birthDate != null)
                && (this._ageRanges != null)) {

                //get the age from the birthdate
                let today: Date = new Date();
                let age: number = today.getFullYear() - birthDate.getFullYear();
                var m = today.getMonth() - birthDate.getMonth();
                if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                    age--;
                }

                //find the best match ageRange for the actual age
                for (var ar in this._ageRanges) {
                    if (age < this._ageRanges[ar].value)
                        break;

                    if (age >= this._ageRanges[ar].value)
                        ageRangeId = this._ageRanges[ar].value;
                }
            }
        }
        catch (e) {
            console.log(e);
            ageRangeId = -1;
        }

        return ageRangeId;
    }

    private getNearestValidTime(origTime: string, edge: enumRentalEdge): string {
        origTime = origTime.trim().toUpperCase();
        let nearestTime: string = origTime;

        switch (edge) {
            case enumRentalEdge.Out:
                if (this._rentalTimesOut != null) {
                    //see if the given time is an exact match for one in the list
                    nearestTime = <string>this._rentalTimesOut.find(x => x.trim().toUpperCase() == origTime);
                    if (nearestTime != null)
                        return nearestTime;

                    //given time is NOT in the list, so find the nearest time (after the given time)
                    for (var rt in this._rentalTimesOut) {
                        if (origTime < this._rentalTimesOut[rt])
                            return this._rentalTimesOut[rt];

                        nearestTime = this._rentalTimesOut[rt];
                    }
                    return nearestTime;
                }
                break;

            case enumRentalEdge.In:
                if (this._rentalTimesIn != null) {
                    //see if the given time is an exact match for one in the list
                    nearestTime = <string>this._rentalTimesIn.find(x => x.trim().toUpperCase() == origTime);
                    if (nearestTime != null)
                        return nearestTime;

                    //given time is NOT in the list, so find the nearest time (before the given time)
                    for (var rt in this._rentalTimesIn) {
                        if (origTime < this._rentalTimesIn[rt])
                            return nearestTime;

                        nearestTime = this._rentalTimesIn[rt];
                    }
                    return nearestTime;
                }
                break;
        }

        return origTime;
    }

    private locationImageURL(loc: Location): string {
        var imageURL = "";

        if (loc != null) {
            if (loc.isAirport)
                imageURL = "airport.png";

            if (imageURL.length > 0)
                imageURL = this._baseIconImgURL + imageURL;
        }

        return imageURL;
    }

    //
    //dialog management
    //
    private dialogButtonPressed(button: DialogButton) {
        //record which button was pressed
        this._dialog.buttonPressed = button;
    }

    //
    //delivery/collection handling
    //
    private showDeliveryCollection(show: boolean, rentalEdge: enumDeliveryCollection = enumDeliveryCollection.Unknown) {
        this._activatedEdge = enumDeliveryCollection.Unknown;

        if (show) {
            this._activatedEdge = rentalEdge;

            this._tmpHasDelivery = (this._hasDelivery || (rentalEdge == enumDeliveryCollection.Delivery));
            this._tmpDeliveryAddress = (this._deliveryAddress == null ? "" : this._deliveryAddress);
            this._tmpHasCollection = (this._hasCollection || (rentalEdge == enumDeliveryCollection.Collection));
            this._tmpCollectionAddress = (this._collectionAddress == null ? "" : this._collectionAddress);
        }

        this._showDelCol = show;
    }

    private delColShow(event: any) {
        this.validateDelCol(this._activatedEdge);
        this.activateDelColCtrl(this._activatedEdge);
        this._activatedEdge = enumDeliveryCollection.Unknown;
    }

    private activateDelColCtrl(rentalEdge: enumDeliveryCollection) {
        switch (rentalEdge) {
            case enumDeliveryCollection.Delivery:
                setTimeout(function () {
                    var delAddr: any = document.getElementById("delAddr");
                    if (delAddr != null) {
                        delAddr.focus();
                        delAddr.select();
                    }
                }, 50);
                break;

            case enumDeliveryCollection.Collection:
                setTimeout(function () {
                    var colAddr: any = document.getElementById("colAddr");
                    if (colAddr != null) {
                        colAddr.focus();
                        colAddr.select();
                    }
                }, 50);
                break;
        }
    }

    private validateDelCol(source: number) {
        switch (source) {
            case enumDeliveryCollection.Delivery:
                //delivery checkbox
                //we've just activated the delivery, so prompt the user if they want to use the collection address
                if (this._tmpHasDelivery)
                    this.useDelColOtherAddress(source);
                else
                    this._tmpDeliveryAddress = "";
                break;

            case enumDeliveryCollection.Collection:
                //collection checkbox
                //we've just activated the collection, so prompt the user if they want to use the delivery address
                if (this._tmpHasCollection)
                    this.useDelColOtherAddress(source);
                else
                    this._tmpCollectionAddress = "";
                break;
        }

        this._hasDeliveryError = ((this._tmpHasDelivery)
            && (this._tmpDeliveryAddress.trim().length == 0));
        this._hasCollectionError = ((this._tmpHasCollection)
            && (this._tmpCollectionAddress.trim().length == 0));

        this._delAddrTextColour = this._hasDeliveryError === true ? this._invalidTextColour : this._textColour;
        this._delAddrBorderColour = this._hasDeliveryError === true ? this._invalidBorderColour : "";
        this._colAddrTextColour = this._hasCollectionError === true ? this._invalidTextColour : this._textColour;
        this._colAddrBorderColour = this._hasCollectionError === true ? this._invalidBorderColour : "";

    }

    private delColClick(action: number) {
        //deliver/collection dialog button pressed
        if (action == 1) {
            //save the changes
            this._hasDelivery = this._tmpHasDelivery;
            this._deliveryAddress = this.cleanMultiLineString(this._tmpDeliveryAddress);
            this._hasCollection = this._tmpHasCollection;
            this._collectionAddress = this.cleanMultiLineString(this._tmpCollectionAddress);

            this.validateDelCol(enumDeliveryCollection.Unknown);
            this.validateForm();
        }

        //hide the delivery/collection dialog
        this.showDeliveryCollection(false);
    }

    private cleanMultiLineString(original: string): string {
        //get rid of any enpty lines in the given multiline string
        //and trim any individual lines
        let result: string = "";

        var originalArray: string[] = original.trim().split("\n");
        for (var i = 0; i < originalArray.length; i++) {
            if (originalArray[i].trim().length > 0)
                result = result
                    + (result.length > 0 ? "\n" : "")
                    + originalArray[i].trim();
        }

        return result;
    }

    private useDelColOtherAddress(delCol: enumDeliveryCollection) {
        let msg: string = "";

        switch (delCol) {
            case enumDeliveryCollection.Delivery:
                if ((!this._tmpHasDelivery)
                    || (!this._tmpHasCollection)
                    || (this._tmpCollectionAddress.length == 0)
                    || (this._tmpDeliveryAddress.length > 0)) {

                    this.activateDelColCtrl(delCol);
                    return;
                }
                msg = "Deliver to the same address as the Collection?";
                break;

            case enumDeliveryCollection.Collection:
                if ((!this._tmpHasCollection)
                    || (!this._tmpHasDelivery)
                    || (this._tmpDeliveryAddress.length == 0)
                    || (this._tmpCollectionAddress.length > 0)) {

                    this.activateDelColCtrl(delCol);
                    return;
                }
                msg = "Collect from the same address as the Delivery?";
                break;

            default:
                return;
        }

        //clear the Dialog object's array of DialogButtons
        this._dialog.buttons = [];

        //apply the required buttons to the Dialog object
        var btnYes: DialogButton = new DialogButton();
        btnYes.label = "Yes";
        btnYes.buttonType = enumDialogButtonType.dlgParam_Yes;
        this._dialog.buttons.push(btnYes);

        var btnNo: DialogButton = new DialogButton();
        btnNo.label = "No";
        btnNo.buttonType = enumDialogButtonType.dlgParam_No;
        this._dialog.buttons.push(btnNo);

        this._confirmationService.confirm({
            message: msg,
            accept: () => {
                switch (this._dialog.buttonPressed.buttonType) {
                    case enumDialogButtonType.dlgParam_Yes:
                        switch (delCol) {
                            case enumDeliveryCollection.Delivery:
                                this._tmpDeliveryAddress = this._tmpCollectionAddress;
                                break;

                            case enumDeliveryCollection.Collection:
                                this._tmpCollectionAddress = this._tmpDeliveryAddress;
                                break;

                            default:
                                return;
                        }

                        this.validateDelCol(enumDeliveryCollection.Unknown);
                        break;

                    case enumDialogButtonType.dlgParam_No:
                        break;
                }

                this.activateDelColCtrl(delCol);
            },
        });
    }

    //
    //location map handling
    //
    private showMap(show: boolean) {
        //show/hide the map as required
        this._showMap = show;
    }

    private configureMap() {
        try {
            this._mapStyle = {
                'width': (window.innerWidth * 0.8) + 'px',
                'height': (window.innerHeight * 0.8) + 'px',
            };

            this._mapOptions = {
                center: { lat: 51.8250, lng: -0.3425 },
                zoom: this._defaultZoom,
                disableDefaultUI: true,
                zoomControl: true,
                zoomControlOptions: {
                    style: google.maps.ZoomControlStyle.LARGE
                },
                mapTypeId: google.maps.MapTypeId.ROADMAP
            };

            //add the location markers to the map
            if (this._locationsOut != null) {
                for (var loc in this._locationsOut) {
                    if ((this._locationsOut[loc].latitude != null)
                        && (this._locationsOut[loc].longitude != null)) {

                        var mapMarker = new google.maps.Marker(
                            {
                                position: {
                                    lat: this._locationsOut[loc].latitude,
                                    lng: this._locationsOut[loc].longitude
                                },
                                title: this._locationsOut[loc].description,
                                icon: (this._locationsOut[loc].locationId == (this._locationOutx == null ? -1 : this._locationOutx.locationId) ? this._baseIconImgURL + "map-marker_red.png" : this._baseIconImgURL + "map-marker_blue.png")
                            });
                        mapMarker.setValues({ id: this._locationsOut[loc].locationId });

                        this._mapOverlays.push(mapMarker);
                    }
                }
            }
        }
        catch (e) {
            console.log(e);
        }
    }

    private mapOverlayClick(event: any) {
        //location selected on the map

        //hide the map
        this.showMap(false);

        var locId = event.overlay.get('id');
        if (locId > 0) {
            //this._locationOutId = locId;
            var locOut: SelectItem = <SelectItem>this._locationsOutx.find(x => x.value.locationId == locId);
            if (locOut != null)
                this._locationOutx = locOut.value;
            else
                this._locationOutx = <Location>{locationId: -1};

            this.validateLocationOut();
        }
    }

    private mapReady(event: any) {
        //get a handle on the map
        this._map = event.map;

        //ensure the markers are displayed properly (icons, positioning, zooming, etc.)
        this.refreshMap(true);
    }

    private refreshMap(rememberAllLocations: boolean = false) {
        var selectedLocIndex: number = -1;
        var bounds = new google.maps.LatLngBounds();

        //loop through all markers, setting the icon as required
        //working out the bounds that cover all markers as we go
        for (var i = 0; i < this._mapOverlays.length; i++) {
            bounds.extend(this._mapOverlays[i].getPosition());

            //if (this._mapOverlays[i].get('id') == this._locationOutId) {
            if (this._mapOverlays[i].get('id') == (this._locationOutx == null ? -1 : this._locationOutx.locationId)) {
                selectedLocIndex = i;

                //ensure the selected location has a red marker
                if (this._mapOverlays[i].getIcon() != this._baseIconImgURL + "map-marker_red.png")
                    this._mapOverlays[i].setIcon(this._baseIconImgURL + "map-marker_red.png");
            }
            else {
                //ensure the un-selected location has a blue marker
                if (this._mapOverlays[i].getIcon() != this._baseIconImgURL + "map-marker_blue.png")
                    this._mapOverlays[i].setIcon(this._baseIconImgURL + "map-marker_blue.png");
            }
        }

        if ((this._map != null)
            && (this._mapOverlays.length > 0)) {

            if (rememberAllLocations) {
                //work out how to rescale and reposition the map to show all locations
                this._allLocationsCentre = bounds.getCenter();
                this._map.setCenter(this._allLocationsCentre);

                //fitBounds is applied asynchronously, so we need to listen for it to apply the change in zoom
                google.maps.event.addListenerOnce(this._map, 'zoom_changed', () => {
                    if (this._map.getZoom() > 15) {
                        this._map.setZoom(15);
                    }
                    this._allLocationsZoom = this._map.getZoom();

                    this.setMapZoom(selectedLocIndex);
                });

                this._map.fitBounds(bounds);
            }
            else
                this.setMapZoom(selectedLocIndex);
        }
    }

    private setMapZoom(selectedLocIndex: number) {
        if (selectedLocIndex >= 0) {
            //center the map on the selected location's marker
            this._map.setCenter(this._mapOverlays[selectedLocIndex].getPosition());
            this._map.setZoom(this._defaultZoom);
        }
        else {
            //no selected location, so show all location markers
            //rescale and reposition the map to show all locations
            //center the map to the geometric center of all markers
            this._map.setCenter(this._allLocationsCentre);
            if (this._allLocationsZoom > 0)
                this._map.setZoom(this._allLocationsZoom);
        }
    }

    private radioImageURL(isSelected: boolean): string {
        let url: string = this._baseIconImgURL + "radio_button_unchecked.png";

        if (isSelected) {
            url = this._baseIconImgURL + "radio_button_checked.png";
        }

        return url;
    }

}
